import React from 'react';
import { ImageElement as ImageType } from '../../types/element.types';

interface ImageElementProps {
  element: ImageType;
}

/**
 * Image Element Renderer
 */
const ImageElement: React.FC<ImageElementProps> = ({ element }) => {
  const { src, alt } = element.content || { src: '', alt: '' };
  const objectFit = element.settings?.objectFit || 'cover';
  const link = element.settings?.link;

  const imageElement = (
    <img
      src={src}
      alt={alt}
      className="image-element"
      style={{
        ...element.styles,
        objectFit,
      } as React.CSSProperties}
    />
  );

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {imageElement}
      </a>
    );
  }

  return imageElement;
};

export default ImageElement;

